module.exports = __webpack_public_path__ + "static/img/3.88f60d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/version/02/3.png
// module id = oxyr
// module chunks = 1